import { Link, useParams, useNavigate } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const PosDevices = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
    terminalId : ''
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    code: "",
    posType: 0,
    connectionType: 0,
    lanIP: "",
    lanPort: "",
    comPort: 0,
    comBaudRate: "",
    serialNo: "",
    terminalId: "",
    acceptorId: "",
    providerId: 0,
    branchId: branchId,
  });
  const [providerNames, setProviderNames] = useState([]);
  const [selectedPos, setSelectedPos] = useState(null);
  const [showModalPosReport, setShowModalPosReport] = useState(false);
  const [posReportData, setPosReportData] = useState([]);
  const [totalSum, setTotalSum] = useState(null);
  const [differenceInDays, setDifferenceInDays] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [posProviderFilterModel, setPosProviderFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });

  const getGridData = async () => {
    const resp = await apiMethod.getPoses(filterModel.branchId, filterModel.size, filterModel.part, filterModel.title , filterModel.terminalId);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getPosProviders(posProviderFilterModel.branchId, posProviderFilterModel.size, posProviderFilterModel.part, posProviderFilterModel.title);
    if (methods.showApiErrors(resp1)) {
      setPosProviderFilterModel({ ...posProviderFilterModel });
      setProviderNames(resp1.data);
    }
  };

  const getPosReport = async (posId, startDate, endDate) => {
    const resp = await apiMethod.getPosReport(posId, startDate, endDate);
    if (methods.showApiErrors(resp)) {
      setPosReportData(resp.data);
      setTotalSum(resp.sum);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      await getBaseInfo();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.code)) {
      errors.push('.کد دستگاه باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.providerId) || formModel.providerId === 0) {
      errors.push('.سرویس دهنده باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.posType) || formModel.posType === 0) {
      errors.push('.نوع باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.connectionType) || formModel.connectionType === 0) {
      errors.push('.نوع اتصال باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.terminalId)) {
      errors.push('شناسه ترمینال باید مقدار داشته باشد.');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.code = "";
    formModel.posType = 0;
    formModel.connectionType = 0;
    formModel.lanIP = "";
    formModel.lanPort = "";
    formModel.comPort = 0;
    formModel.comBaudRate = "";
    formModel.serialNo = "";
    formModel.terminalId = "";
    formModel.acceptorId = "";
    formModel.providerId = 0;
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.unitId = 0;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.terminalId = ""
    setFilterModel({ ...filterModel })
  };

  const editItem = async (id) => {

    setLoading(true);
    const resp = await apiMethod.getPosInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.code = resp.data.code;
    formModel.posType = resp.data.posType;
    formModel.connectionType = resp.data.connectionType;
    formModel.lanIP = resp.data.lanIP;
    formModel.lanPort = resp.data.lanPort;
    formModel.comPort = resp.data.comPort;
    formModel.comBaudRate = resp.data.comBaudRate;
    formModel.serialNo = resp.data.serialNo;
    formModel.terminalId = resp.data.terminalId;
    formModel.acceptorId = resp.data.acceptorId;
    formModel.providerId = resp.data.providerId;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createPos(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const showPosReport = () => {

    const differenceInMs = Math.abs(endDate - startDate);
    const days = differenceInMs / (1000 * 60 * 60 * 24);
    setDifferenceInDays(days);

    // Convert startdate & endDate  
    const formattedStartDate = startDate.toString().slice(0, 10).replace(/-/g, '/');
    const formattedEndDate = endDate.toString().slice(0, 10).replace(/-/g, '/');
    setLoading(true);
    getPosReport(selectedPos.id, formattedStartDate, formattedEndDate)
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const getPosTypeString = (posType) => {
    switch (posType) {
      case 1:
        return "ثابت";
      case 2:
        return "سیار";
      default:
        return "";
    }
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#3`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#3`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                دستگاه های پوز
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>دستگاه های پوز
                <a href={`/sale/${branchId}/softwareGuide/#section7`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-6 col-lg-3'>
                    <label htmlFor="searchInput" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                    </div>
                  </div>
                  <div className='col-12 col-md-6 col-lg-3'>
                    <label htmlFor='terminal' className="form-label">شماره ترمینال</label>
                      <input id="terminal"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.terminalId}
                        onChange={(e) => setFilterModel({...filterModel , terminalId : e.target.value})}
                        />
                  </div>
                  <div className='col-2 d-flex align-items-end' style={{ marginBottom : "4px" }}>
                  <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                  </div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => navigate(`/sale/${branchId}/posDevices/banks`)}
                        className='btn btn-link-purple custome-btn ms-2' type='button'>بانک‌ها
                      </button>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>پوز جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">سرویس دهنده</th>
                      <th scope="col vertical-center">شماره ترمینال</th>
                      <th scope="col vertical-center">نوع</th>
                      <th scope="col vertical-center">گزارش</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                        <td>{item.title}</td>
                        <td>{item.providerTitle}</td>
                        <td>{item.terminalId}</td>
                        <td>{getPosTypeString(item.posType)}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() => openModalPosReport(item)} >
                            گزارش پوز
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(item.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removePosDevice(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش پوز</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="title" className="form-label required-label">عنوان</label>
                  <input type="text" className="form-control" id="title" name="title"
                    value={formModel.title}
                    onChange={(e) => { setFormModel({ ...formModel, title: e.target.value }) }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="code" className="form-label required-label">کد دستگاه در شعبه</label>
                  <input type="text" className="form-control"
                    id="code" name="code"
                    value={formModel.code || ''}
                    onChange={(e) => { setFormModel({ ...formModel, code: e.target.value }) }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="employeetype" className="form-label required-label">سرویس دهنده</label>
                  <select
                    id="provider"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.providerId}
                    onChange={(e) => {
                      formModel.providerId = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {providerNames.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="city" className="form-label required-label">نوع</label>
                  <select
                    id="type"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.posType}
                    onChange={(e) => {
                      formModel.posType = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="1">ثابت</option>
                    <option value="2">سیار</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="city" className="form-label required-label">
                    نوع اتصال
                  </label>
                  <select
                    id="connectionType"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.connectionType}
                    onChange={(e) => {
                      formModel.connectionType = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value="1">LAN</option>
                    <option value="2">COM</option>
                    <option value="3">Internet</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="serialNo" className="form-label">شماره سریال(Serial No)</label>
                  <input type="text" className="form-control" id="serialNo" name="serialNo"
                    value={formModel.serialNo}
                    onChange={(e) => { setFormModel({ ...formModel, serialNo: e.target.value }) }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="terminalId" className="form-label required-label">شناسه ترمینال(Terminal ID)</label>
                  <input type="text" className="form-control" id="terminalId" name="terminalId"
                    value={formModel.terminalId}
                    onChange={(e) => { setFormModel({ ...formModel, terminalId: e.target.value }) }}
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="acceptorId" className="form-label">کد پذیرنده(Acceptor ID)</label>
                  <input type="text" className="form-control" id="acceptorId" name="acceptorId"
                    value={formModel.acceptorId || ""}
                    onChange={(e) => { setFormModel({ ...formModel, acceptorId: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50"
                onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  const openModalPosReport = (item) => {
    setSelectedPos(item);
    setShowModalPosReport(true);
  };

  const closeModalPosReport = () => {
    setShowModalPosReport(false);
    setPosReportData([]);
    setTotalSum(null);
    setSelectedPos(null);
    setDifferenceInDays(0);
  };

  const ModalPosReport = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showModalPosReport ? 'block' : 'none' }}>
        <div className="modal-dialog modal-xl" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">گزارش پوز</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModalPosReport}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className=''>
                <div className='d-lg-flex justify-content-start my-3'>
                  <p className='col-md-4'>ترمینال: {selectedPos.terminalId}</p>
                  <p className='col-md-4'>مبلغ کل: {methods.addNumSeperator(totalSum !== null ? totalSum.toLocaleString() : '')}</p>
                </div>
                <p className='noticeforpos col-md-4'>
                  <i className="bi bi-info-circle-fill ms-2"></i>
                  بازه انتخاب تاریخ باید کمتر از ۴۰ روز باشد.
                </p>
                <div className='d-lg-flex justify-content-start align-items-baseline'>
                  <div className='col-md-4'>
                    <label htmlFor="code" className="form-label">از تاریخ</label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      onChange={setStartDate}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%"
                      }}
                    />
                  </div>
                  <div className='col-md-4 ms-2'>
                    <label htmlFor="code" className="form-label">تا تاریخ</label>
                    <DatePicker
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-center"
                      format="YYYY/MM/DD"
                      onChange={setEndDate}
                      inputClass="form-control"
                      containerStyle={{
                        width: "100%"
                      }}
                    />
                  </div>
                </div>
                {(differenceInDays > 40) ? (
                  <p className='errortextpos'>
                    بازه انتخاب تاریخ باید کمتر از ۴۰ روز باشد.
                  </p>
                ) :
                  <p></p>
                }
                <div className='text-center'>
                  <button
                    type='button'
                    className='btn custome-btn btn-purple mt-4 '
                    onClick={showPosReport}
                  >گرفتن گزارش</button>
                </div>
              </div>
              {loading ?
                <div className="text-center">
                  <div className="spinner-border text-secondary my-5" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
                :
                <div className='table-responsive saletable'>
                  <table className="table table-striped table-md">
                    <thead className='align-middle'>
                      <tr>
                        <th scope="col vertical-center" width="20px">ردیف</th>
                        <th scope="col vertical-center"> مبلغ (ریال) </th>
                        <th scope="col vertical-center">شماره کارت</th>
                        <th scope="col vertical-center">شماره تراکنش</th>
                        <th scope="col vertical-center">ترمینال</th>
                        <th scope="col vertical-center">تاریخ</th>
                      </tr>
                    </thead>
                    <tbody className='align-middle'>
                      {differenceInDays < 40 && posReportData.map((item, index) => (
                        <tr key={item.ptraceno}>
                          <th scope="row">{index + 1}</th>
                          <td>{methods.addNumSeperator(item.originalamount)}</td>
                          <td>{item.pan}</td>
                          <td>{item.straceno}</td>
                          <td>{item.termid}</td>
                          <td>{item.stracedt}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              }
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple ms-1"
              // onClick={() => navigate(`/sale/${branchId}/posDevices/banks`)}
              >
                پرینت گزارش
              </button>
              <button
                type="button"
                className="btn custome-btn btn-purple ms-1"
              // onClick={() => navigate(`/sale/${branchId}/posDevices/banks`)}
              >
                بارگذاری اکسل
              </button>
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModalPosReport}
              >
                انصراف
              </button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'پوز'}
        />
      }
      {showModalPosReport && ModalPosReport()}
    </>
  );

}

export default PosDevices;